module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_0-5b42979d073473a90344b29a1f11aa50.jpg";